import React, { useState } from 'react'
import { FileText, Eye, MessageSquare, Edit3, ChevronRight } from 'lucide-react'

const SnippetPanel = ({ snippets = [], onSelect }) => {
  const [expanded, setExpanded] = useState({})
  if (!snippets || snippets.length === 0) return null

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm max-w-4xl mx-auto w-full mb-6 overflow-hidden">
      <div className="p-4 border-b border-gray-100 bg-gray-50/50 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="p-1.5 bg-indigo-100 text-indigo-600 rounded-md">
            <FileText size={16} />
          </div>
          <h4 className="font-semibold text-gray-900">Relevant Snippets</h4>
        </div>
        <div className="text-xs text-gray-500 font-medium bg-white px-2 py-1 rounded border border-gray-200">
          {snippets.length} found
        </div>
      </div>

      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
        {snippets.map(s => (
          <div
            key={s.id}
            className={`border rounded-xl transition-all duration-200 ${expanded[s.id]
                ? 'border-blue-200 shadow-md bg-blue-50/30'
                : 'border-gray-200 hover:border-blue-300 hover:shadow-sm bg-white'
              }`}
          >
            <div
              role="button"
              tabIndex={0}
              className="p-3 cursor-pointer"
              onClick={() => setExpanded(prev => ({ ...prev, [s.id]: !prev[s.id] }))}
              onKeyDown={(e) => { if (e.key === 'Enter') setExpanded(prev => ({ ...prev, [s.id]: !prev[s.id] })) }}
            >
              <div className="flex justify-between items-start gap-3">
                <div>
                  <div className="font-semibold text-sm text-gray-900 mb-1">{s.title}</div>
                  <div className="text-xs text-gray-500 line-clamp-2 leading-relaxed">
                    {s.text}
                  </div>
                </div>
                <button className={`text-gray-400 transition-transform duration-200 ${expanded[s.id] ? 'rotate-90 text-blue-500' : ''}`}>
                  <ChevronRight size={16} />
                </button>
              </div>
            </div>

            {expanded[s.id] && (
              <div className="px-3 pb-3 pt-0 animate-in fade-in slide-in-from-top-1 duration-200">
                <div className="mt-2 p-3 bg-white rounded-lg border border-blue-100 text-sm text-gray-700 leading-relaxed shadow-inner">
                  {s.text}
                </div>
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={() => onSelect(s)}
                    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
                  >
                    <MessageSquare size={14} />
                    Discuss
                  </button>
                  <button
                    onClick={() => onSelect(s)}
                    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-white border border-gray-200 text-gray-700 text-xs font-medium rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                  >
                    <Edit3 size={14} />
                    Rewrite
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default SnippetPanel
